import { render, staticRenderFns } from "./CommandSettings.vue?vue&type=template&id=bcfdc440"
import script from "./CommandSettings.vue?vue&type=script&lang=js"
export * from "./CommandSettings.vue?vue&type=script&lang=js"
import style0 from "./CommandSettings.vue?vue&type=style&index=0&id=bcfdc440&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports